import { render, staticRenderFns } from "./TranProgramProgramModuleListFilter.vue?vue&type=template&id=3afc40a4&scoped=true"
import script from "./TranProgramProgramModuleListFilter.vue?vue&type=script&lang=js"
export * from "./TranProgramProgramModuleListFilter.vue?vue&type=script&lang=js"
import style0 from "./TranProgramProgramModuleListFilter.vue?vue&type=style&index=0&id=3afc40a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc40a4",
  null
  
)

export default component.exports